import { makeStyles, Theme, createStyles } from '@material-ui/core';
import {
  IMAGE_AREA_WIDTH_2_3,
  IMAGE_AREA_HEIGHT_2_3,
  IMAGE_AREA_WIDTH_9_16,
  IMAGE_AREA_HEIGHT_9_16,
} from 'constants/style';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerHorizontal: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: IMAGE_AREA_WIDTH_9_16,
      height: IMAGE_AREA_HEIGHT_9_16,
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(2),
    },
    containerVertical: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: IMAGE_AREA_WIDTH_2_3,
      height: IMAGE_AREA_HEIGHT_2_3,
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(2),
    },
    noImageText: {
      color: theme.palette.text.disabled,
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      borderRadius: theme.spacing(1),
      width: '90%',
      marginLeft: 10,
      marginRight: 10,
      padding: 10,
    },
    text: {
      color: theme.palette.common.white,
      fontSize: 11,
      textAlign: 'center',
      wordWrap: 'break-word',
      flexWrap: 'wrap',
      width: '90%',
    },
  }),
);

export const backGroundStyle = (image: string): any => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    height: '100%',
    width: '100%',
  };
};

export default useStyles;
